import { useState, useEffect } from "react";
import { Button, Input, Select, Form, Modal, Checkbox } from "antd";
import {
  logTypeOptions,
  logTypeComplaintOptions,
  siteReadinessStatusOptions
} from "../../constants/helperConstants";
import { requiredDateTimeFormat, localizeDateTime } from "../../utils";

const ConnectLogForm = (props: any) => {
  const [form] = Form.useForm();
  const {
    isOpen,
    handleCancel,
    onAddCallLog,
    onUpdateCallLog,
    selectedCallLogData,
    assignment,
    title,
    msil,
    nextFollowUpRequired,
    isEditMode
  } = props;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEditMode === true) {
      const next_follow_up_at = requiredDateTimeFormat(selectedCallLogData?.next_follow_up_at);
      form.setFieldValue("next_follow_up_at", next_follow_up_at);
    }
  }, []);

  const onFinish = (values: any) => {
    setLoading(true);
    if (values?.next_follow_up_at) {
      values["next_follow_up_at"] = new Date(values?.next_follow_up_at).toISOString();
    }
    if (selectedCallLogData?.id) {
      values["id"] = selectedCallLogData?.id;
      const data = {
        id: assignment?.id,
        call_log: values
      };
      onUpdateCallLog(data, setLoading, form);
    } else {
      const data = { id: assignment?.id, call_log: values };
      onAddCallLog(data, setLoading, form);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <Modal
      title={title}
      open={isOpen}
      onCancel={handleCancel}
      onOk={onFinish}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Cancel
        </Button>,
        <Button
          form="connect_log_form"
          key="submit"
          loading={loading}
          htmlType="submit"
          type="primary"
        >
          {isEditMode ? "Update" : "Create"}
        </Button>
      ]}
    >
      <Form
        name="connect_log_form"
        form={form}
        initialValues={selectedCallLogData}
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        style={{ padding: "20px" }}
      >
        <Form.Item label="Summary" name="summary">
          <Input />
        </Form.Item>

        <Form.Item label="Log Type" name="log_type">
          <Select
            placeholder="Select log type"
            showSearch
            optionFilterProp="children"
            options={props.booking ? logTypeOptions : logTypeComplaintOptions}
            filterOption={(inputValue, option: any) =>
              option.label.toLowerCase().includes(inputValue.toLowerCase())
            }
          />
        </Form.Item>

        {msil && (
          <Form.Item
            label="MSIL Site Readiness Status"
            name="msil_site_readiness_status"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Select
              placeholder="Select MSIL site Readiness Status"
              showSearch
              optionFilterProp="children"
              options={siteReadinessStatusOptions}
              filterOption={(inputValue, option: any) =>
                option.label.toLowerCase().includes(inputValue.toLowerCase())
              }
            />
          </Form.Item>
        )}

        <Form.Item label="Call Connected" valuePropName="checked" name="call_connected">
          <Checkbox>Tick if call connected</Checkbox>
        </Form.Item>

        <Form.Item
          label="Next Follow Up At"
          name="next_follow_up_at"
          rules={[{ required: nextFollowUpRequired, message: "This field is required" }]}
        >
          <Input type="datetime-local" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ConnectLogForm;
